export default __webpack_public_path__ + "static/media/MacCoyBenzen.d37b74df.jpg";